import * as React from 'react';
import { Dropdown, Input } from 'semantic-ui-react';

import paisesOptions from './paisesOptions';

export interface PasaporteProps {
    pais: string;
    pasaporte: string;
    requerido?: boolean;
    alCambiarPais(pais: string): void;
    alCambiarPasaporte(pasaporte: string): void;
}

export const Pasaporte: React.FunctionComponent<PasaporteProps> = props => {
    const { pais, pasaporte, requerido = false, alCambiarPais, alCambiarPasaporte } = props;

    return (
        <Input
            placeholder='102008A'
            type='text'
            label={
                <Dropdown
                    options={paisesOptions}
                    value={pais}
                    onChange={(_e, { value }) => {
                        alCambiarPais(value as string);
                    }}
                    search
                    button
                    noResultsMessage='No hay resultados.'
                />
            }
            value={pasaporte}
            onChange={(_e, { value }) => {
                alCambiarPasaporte(formatearPasaporte(value));
            }}
            required={requerido}
        />
    );
};

function formatearPasaporte(texto: string) {
    const soloNumerosLetrasGuion = texto.replace(/[^\w\-]/g, '');
    return soloNumerosLetrasGuion.toUpperCase();
}

export default Pasaporte;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/RutPasaporte/componentes/Pasaporte/index.tsx